import { Form, useFormikContext } from 'formik';

import { Button } from '../../../cdl/Button/Button';
import { DrawerContentLayout } from '../../../cdl/Drawer/DrawerContentLayout';
import { FormikCustomerCompanySelect } from '../../../common/form-elements/formik/FormikCustomerCompanySelect';
import { FormikDebug } from '../../../common/form-elements/formik/FormikDebug';
import { FormikSupplierCompanySelect } from '../../../common/form-elements/formik/FormikSupplierCompanySelect';
import { translate } from '../../../common/helpers/translate.helper';

export interface FormikAssignmentState {
    customerId: string;
    supplierId: string;
}

interface AssignmentBaseFormProps {
    primaryActionText: string;
}

export const AssignmentBaseForm = (props: AssignmentBaseFormProps) => {
    const { isSubmitting, dirty } = useFormikContext<FormikAssignmentState>();
    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={isSubmitting}
                hasUnsavedChanges={dirty}
                primaryAction={
                    <Button type="submit" emphasis="high" isLoading={isSubmitting}>
                        {props.primaryActionText}
                    </Button>
                }
            >
                <FormikCustomerCompanySelect name="customerId" label={translate('assignments.customer')} />
                <FormikSupplierCompanySelect name="supplierId" label={translate('assignments.supplier')} />
                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
